/* import __COLOCATED_TEMPLATE__ from './business-invalid-address.hbs'; */
import Component from '@glimmer/component';
import { feature } from '@square/ember-features/macros';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { initializeAction } from '@banking/ui/workflows/onboarding-kyb/action';
import CurrentApplicationFlow from '@banking/api/services/current-application-flow';
import type RouterService from '@ember/routing/router-service';
import type KybWorkflow from '@banking/savings-onboarding-app/services/kyb-workflow';

export default class BusinessInvalidAddressComponent extends Component {
  @service currentApplicationFlow!: CurrentApplicationFlow;
  @service kybWorkflow!: KybWorkflow;
  @service router!: RouterService;

  @feature('banking/stop_prefilling_savings_onboarding')
  declare stopPrefilling: boolean;

  @action
  continue() {
    if (this.stopPrefilling) {
      this.router.transitionTo('signup.business-type');
      this.initKyb();
    } else {
      this.router.transitionTo('signup.confirm-business.index');
    }
  }

  @action
  navigateToEdit() {
    const route = this.stopPrefilling
      ? 'signup.enter-business-info'
      : 'signup.confirm-business.edit';
    this.router.transitionTo(route);
  }

  initKyb() {
    const initialize = initializeAction({
      businessName: this.currentApplicationFlow.business?.businessName || '',
      entityType: this.currentApplicationFlow.business?.businessType,
      taxIdSerialNumber: this.currentApplicationFlow.business?.businessEinLast4,
      existingIndividuals: this.currentApplicationFlow.controllingIndividuals,
    });

    this.kybWorkflow.emit(initialize);
  }
}
